import {
  ADD_CITY,
  ADD_CITY_ERROR,
  ADD_CITY_SUCCESS,
  DELETE_CITY,
  DELETE_CITY_ERROR,
  DELETE_CITY_SUCCESS,
  GET_CITIES,
  GET_CITIES_ERROR,
  GET_CITIES_SUCCESS,
  GET_CITY,
  GET_CITY_SUCCESS,
  UPDATE_CITY,
  UPDATE_CITY_ERROR,
  UPDATE_CITY_SUCCESS,
  TOGGLE_CITY_MODAL,
} from "./actionTypes";

export const getCities = (request) => {
  return {
    type: GET_CITIES,
    payload: { request },
  };
};

export const getCitiesSuccess = (paginatedServices) => {
  return {
    type: GET_CITIES_SUCCESS,
    payload: paginatedServices,
  };
};

export const getCitiesError = (message) => {
  return {
    type: GET_CITIES_ERROR,
    payload: message,
  };
};

export const addCity = (request) => {
  return {
    type: ADD_CITY,
    payload: { request },
  };
};

export const addCitySuccess = () => {
  return {
    type: ADD_CITY_SUCCESS,
  };
};

export const addCityError = (error) => {
  return {
    type: ADD_CITY_ERROR,
    payload: error,
  };
};

export const getCity = (id) => {
  return {
    type: GET_CITY,
    payload: { id },
  };
};

export const getCitySuccess = (customer) => {
  return {
    type: GET_CITY_SUCCESS,
    payload: customer,
  };
};

export const getCityError = (message) => {
  return {
    type: GET_CITIES_ERROR,
    payload: message,
  };
};

export const updateCity = (request) => {
  return {
    type: UPDATE_CITY,
    payload: { request },
  };
};

export const updateCitySuccess = () => {
  return {
    type: UPDATE_CITY_SUCCESS,
  };
};

export const updateCityError = (error) => {
  return {
    type: UPDATE_CITY_ERROR,
    payload: error,
  };
};

export const deleteCity = (id) => {
  return {
    type: DELETE_CITY,
    payload: { id },
  };
};

export const deleteCitySuccess = () => {
  return {
    type: DELETE_CITY_SUCCESS,
  };
};

export const deleteCityError = (error) => {
  return {
    type: DELETE_CITY_ERROR,
    payload: error,
  };
};

export const toggleCityModalAction = () => {
  return {
    type: TOGGLE_CITY_MODAL,
  };
};
